import { Badge } from '@/components/ui/badge';
import type { ReceivingOrderStatus } from '../../types';

interface ReceivingStatusBadgeProps {
  status: ReceivingOrderStatus;
}

const statusConfig: Record<ReceivingOrderStatus, { label: string; variant: 'default' | 'secondary' | 'outline' | 'destructive' }> = {
  draft: { label: 'Draft', variant: 'secondary' },
  in_progress: { label: 'In Progress', variant: 'default' },
  pending_qc: { label: 'Pending QC', variant: 'outline' },
  completed: { label: 'Completed', variant: 'default' },
  cancelled: { label: 'Cancelled', variant: 'destructive' },
};

export function ReceivingStatusBadge({ status }: ReceivingStatusBadgeProps) {
  const config = statusConfig[status] || { label: status, variant: 'secondary' as const };

  const colorClasses: Record<ReceivingOrderStatus, string> = {
    draft: 'bg-gray-100 text-gray-800 hover:bg-gray-100',
    in_progress: 'bg-yellow-100 text-yellow-800 hover:bg-yellow-100',
    pending_qc: 'bg-orange-100 text-orange-800 hover:bg-orange-100',
    completed: 'bg-green-100 text-green-800 hover:bg-green-100',
    cancelled: 'bg-red-100 text-red-800 hover:bg-red-100',
  };

  return (
    <Badge
      variant={config.variant}
      className={colorClasses[status]}
    >
      {config.label}
    </Badge>
  );
}
